import React from 'react';
import { Box, Typography } from '@mui/material';
import MobileRowActions from '../../../../components/datagridComponents/MobileRowActions';
import { Product } from '../../../../types';

export const MobileRowMainContent = ({ data }: { data: Product }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="body1" sx={{ marginBottom: '0.25rem', fontWeight: 600 }}>
        {data.Name}
      </Typography>
      <Typography variant="body2">{data?.Description}</Typography>
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        width: '20%',
        marginRight: '-0.5rem',
      }}
    >
      <MobileRowActions objectId={data.Id} />
    </Box>
  </Box>
);

export default MobileRowMainContent;
